// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.featuresbeta.RentalManagerUserFeaturesBetaWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { FeaturesBetaDetailsResponseDto } from '../..';

interface DetailsParams {
  featureName: string;
}

export const RentalManagerUserFeaturesBetaWebApiHandler_details_Path = '/api/web/v1/users/featuresBeta/details';

/**
 * Get the current user's beta status and opt-in prompt for a beta feature
 */
export const RentalManagerUserFeaturesBetaWebApiHandler_details = (getParams: DetailsParams, client = getClient()) => {
  return httpFrontEndRequest<DetailsParams, never, FeaturesBetaDetailsResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserFeaturesBetaWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFeaturesBetaWebApiHandler_enroll_Path = '/api/web/v1/users/featuresBeta/enroll';

/**
 * Accept the features beta terms and enroll the current user in the features beta
 */
export const RentalManagerUserFeaturesBetaWebApiHandler_enroll = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserFeaturesBetaWebApiHandler_enroll_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserFeaturesBetaWebApiHandler_unenroll_Path = '/api/web/v1/users/featuresBeta/unenroll';

/**
 * Remove the current user from the features beta
 */
export const RentalManagerUserFeaturesBetaWebApiHandler_unenroll = (client = getClient()) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserFeaturesBetaWebApiHandler_unenroll_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
